import axios from "axios";
import { GetNotificationsPreviewResponse, toNotificationsPreviewModel } from "../../../../../pages/logged-in-home-page/api/contracts/get-notifications-preview.response";
import { authorizationHeaders } from "../../../../apis/auth";
import { Urls } from "../../../../apis/urls";
import { NotificationsPreviewModel } from "../models/notifications-preview.model";

export async function getNotificationsPreview(): Promise<NotificationsPreviewModel> {
    const { data } = await axios.get<GetNotificationsPreviewResponse>(Urls.getNotificationsPreview(), authorizationHeaders());
    return toNotificationsPreviewModel(data);
}